import { render } from "./Contador.vue?vue&type=template&id=fc02e336"
import script from "./Contador.vue?vue&type=script&lang=js"
export * from "./Contador.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__